export const API_ENDPOINTS = {
  SCOPE_FILTER: '/api/scopefilter',
  USED_EXPERIENCES: '/api/analytics/admin/sessions/used-experiences',
} as const;

export const QUERY_KEYS = {
  FILTERS_UNITS: ['filters', 'units'],
  FILTERS_EXPERIENCES: ['filters', 'experiences'],
  FILTERS_SESSIONS: ['filters', 'sessions'],
  DROPDOWN_DATA: 'dropdown-data',
} as const;

export const CACHE_CONFIG = {
  UNITS: {
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  },
  EXPERIENCES: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  },
  SESSIONS: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  },
  DROPDOWN: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  },
} as const;

export const RETRY_CONFIG = {
  maxRetries: 2,
  shouldRetry: (failureCount: number, error: Error) => {
    if (error.message.includes('403') || error.message.includes('401')) {
      return false;
    }
    return failureCount < 2;
  },
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 10000),
};
